import request from "./request";

const getWgycAnyday = (date) => {
    return request({
        method: "GET",
        url: "/WGYC/anyday?date=" + date
    })
}

const getWgycAllowedDate = () => {
    return request({
        method: "GET",
        url: "/WGYC/allowedDate"
    })
}

export { getWgycAllowedDate, getWgycAnyday };

